/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAEjectIcon20Solid = forwardRef('MediaUiAEjectIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "m3.368 10.583 5.445-7.047a1.5 1.5 0 0 1 2.374 0l5.445 7.047c.762.986.06 2.417-1.187 2.417H4.555c-1.246 0-1.95-1.431-1.187-2.417Z" }),
        React.createElement("path", { d: "M4 15a1 1 0 1 0 0 2h12a1 1 0 0 0 0-2H4Z" })));
});
